import { ClockCircleOutlined } from '@ant-design/icons';
import { Card, Space } from 'antd';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { getItemsExpiry } from '../../dashboardActions';

const expiryLabelsMap = {
    "0_7": "0–7 Days",
    "7_30": "7 – 30 Days",
    "30_180": "30 – 180 Days",
    "180_": "180+ Days"
};

const expiryColorMap = {
    "0_7": "#e0564b",
    "7_30": "#f4c430",
    "30_180": "#ff9734",
    "180_": "#00b89c",
};

const NearExpiry = () => {
    const [categories, setCategories] = useState([]);
    const [quantities, setQuantities] = useState([]);
    const [colors, setColors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getItemsExpiry().then((data) => {
            const filtered = data?.items_expiry?.filter(item => item.expiry_range !== 'no_expiry');

            const order = ['0_7', '7_30', '30_180', '180_'];

            const sorted = filtered
                .filter(item => order.includes(item.expiry_range))
                .sort((a, b) => order.indexOf(a.expiry_range) - order.indexOf(b.expiry_range));

            const newCategories = sorted.map(item => expiryLabelsMap[item.expiry_range]);
            const newQuantities = sorted.map(item => Number(item.total_quantity));
            const newColors = sorted.map(
                (item) => expiryColorMap[item.expiry_range]
            );

            setCategories(newCategories);
            setQuantities(newQuantities);
            setColors(newColors);
        }).finally(() => {
            setLoading(false);
        })
    }, []);

    const options = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
                distributed: true,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last'
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories,
            title: { text: 'Number of Quantities' }
        },
        colors: colors,
        grid: {
            borderColor: '#eee',
            strokeDashArray: 5,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } }
        }
    };

    const series = [{
        name: 'Quantities',
        data: quantities
    }];

    return (
        <Card
            title={
                <Space>
                    <ClockCircleOutlined style={{ color: '#ff7043' }} />
                    <span style={{ fontWeight: 600 }}>Items Near Expiry</span>
                </Space>
            }
            styles={{
                header: { background: '#f5f5f5' },
                body: { padding: '24px' }
            }}
            style={{
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                border: '1px solid #f0f0f0',
                height: '100%'
            }}
            loading={loading}
        >
            <Chart options={options} series={series} type="bar" height={350} />
        </Card>
    );
};

export default NearExpiry;